import { Environment } from "@/services/Environment";
import StripeRedirect from "@/views/StripeRedirect";
import Vue from "vue";
import VueRouter from "vue-router";
import Checkin from "../views/Checkin.vue";
import CustomPage from "../views/CustomPage.vue";
import CustomPages from "../views/CustomPages.vue";
import DocumentTemplate from "../views/DocumentTemplate.vue";
import EditMember from "../views/EditMember.vue";
import FullScreenCheckins from "../views/FullScreenCheckins.vue";
import FullScreenTimer from "../views/FullScreenTimer.vue";
import InactiveAccount from "../views/InactiveAccount.vue";
import Login from "../views/Login.vue";
import MemberDocuments from "../views/MemberDocuments.vue";
import NotFound from "../views/NotFound.vue";
import Products from "../views/Products.vue";
import StaffCheckin from "../views/StaffCheckin.vue";
import Waiver from "../views/Waiver.vue";

Vue.use(VueRouter);

function isLoggedIn(to, from, next) {
  //console.log('Token? ', localStorage.token ? 'Yes' : 'No')
  if (localStorage.tablet_token) {
    //console.log('Continuing execution to next()')
    next();
  } else {
    console.log("Sending to next(false)");
    next("/login");
  }
}

function alreadyLoggedIn(to, from, next) {
  if (localStorage.tablet_token) {
    next("/checkin");
  } else {
    next();
  }
}

const routes = [
  {
    path: "/",
    name: "home",
    component: Login,
    beforeEnter: (to, from, next) => {
      alreadyLoggedIn(to, from, next);
    },
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    beforeEnter: (to, from, next) => {
      alreadyLoggedIn(to, from, next);
    },
  },
  {
    path: "/checkin",
    name: "checkin",
    component: Checkin,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/staffcheckin",
    name: "staffcheckin",
    component: StaffCheckin,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/waiver",
    name: "waiver",
    component: Waiver,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/products",
    name: "products",
    component: Products,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/stripe_redirect/session/:sessionId",
    name: "striperedirect_session",
    component: StripeRedirect,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/template/:templateId/:memberId",
    name: "template",
    component: DocumentTemplate,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/custom-pages",
    name: "custompages",
    component: CustomPages,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/custom-page",
    name: "custompage",
    component: CustomPage,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/edit-member",
    name: "editmember",
    component: EditMember,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/member-documents/:memberId",
    name: "viewmemberdocuments",
    component: MemberDocuments,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/full-screen-checkins",
    name: "full-screen-checkins",
    component: FullScreenCheckins,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/full-screen-timer",
    name: "full-screen-timer",
    component: FullScreenTimer,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/inactive",
    name: "inactiveaccount",
    component: InactiveAccount,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
  {
    path: "/*",
    name: "notfound",
    component: NotFound,
    beforeEnter: (to, from, next) => {
      isLoggedIn(to, from, next);
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: Environment.get("BASE_URL"),
  routes,
});

export default router;
